import React from "react";
import { observer } from "mobx-react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/buttons";
import { Link } from "react-router-dom";
import { getCurrentCulture } from "@utils";
import { usePartnerRegistrationStore } from "@state/context/membership/registration-types/PartnerRegistrationStoreContext";
import {
	RegistrationCountry,
	RegistrationDOB,
	RegistrationEmail,
	RegistrationFirstName,
	RegistrationLastName,
	RegistrationPassword,
	RegistrationPhone,
	RegistrationState,
	RegistrationUsername,
} from "@features/membership/mobile/registration-types/registration";
import {
	PartnerRegistrationTitle,
	PartnerRegistrationBirthName,
} from "@features/membership/mobile/registration-types/partner-registration";
import { useFormContext } from "react-hook-form";
import { useRootAppStore } from "@hooks";

export const PartnerRegistrationAccountDetails = observer(
	function PartnerRegistrationAccountDetails() {
		const { t } = useTranslation("registration");
		const { trigger } = useFormContext();

		const { isIpRestricted } = useRootAppStore();

		const {
			titleData,
			countryData,
			countryRegionsData,
			checkUserNameAvailability,
			checkIsEmailAvailable,
			checkPasswordSimilarity,
			setCurrentStep,
			toggleStepSwitchFlag,
			isSwitchingSteps,
		} = usePartnerRegistrationStore();

		return (
			<>
				<div className="card--membership__form">
					<PartnerRegistrationTitle titleData={titleData} />

					<div className="form__field u-mar--bottom--reset">
						<div className="row form--grid__row">
							<div className="col col-sml-6 form--grid__col">
								<RegistrationFirstName labelClassName="label--strong" />
							</div>
							<div className="col col-sml-6 form--grid__col">
								<RegistrationLastName labelClassName="label--strong" />
							</div>
						</div>
					</div>

					<PartnerRegistrationBirthName labelClassName="label--strong" />

					<RegistrationDOB
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationCountry
						countryData={countryData}
						labelClassName="label--strong"
					/>

					<RegistrationState
						countryRegionsData={countryRegionsData}
						labelClassName="label--strong"
					/>

					<RegistrationUsername
						checkUserNameAvailability={checkUserNameAvailability}
						labelClassName="label--strong"
					/>

					<RegistrationPassword
						checkPasswordSimilarity={checkPasswordSimilarity}
						labelClassName="label--strong"
					/>

					<RegistrationEmail
						checkIsEmailAvailable={checkIsEmailAvailable}
						labelClassName="label--strong"
					/>

					<RegistrationPhone
						labelClassName="label--strong"
						required
					/>
				</div>

				<Button
					atClassName="regDetailsBtnNext"
					className="btn--base btn--block btn--accent"
					iconRight
					iconClassName="u-icon--tny u-icon--arrow-right u-color--accent--text"
					btnText={t("COMMON.NEXT_BUTTON")}
					type="button"
					isLoading={isSwitchingSteps}
					disabled={isIpRestricted}
					onClick={async () => {
						toggleStepSwitchFlag(true);
						const isValid = await trigger();

						if (isValid) {
							setCurrentStep(2, true);
						}
						toggleStepSwitchFlag(false);
					}}
				/>

				<div className="card--membership__footer">
					{t("EXISTING_ACCOUNT")}
					<Link
						to={`/${getCurrentCulture()}/auth/login`}
						className="u-anchor u-anchor--primary u-anchor--underline"
					>
						&nbsp;
						{t("COMMON.LOGIN_BUTTON")}
					</Link>
				</div>
			</>
		);
	}
);
